import { fontList } from '../../core/font-list';
import { colorListPairs, colorMap } from '../../core/color-list';

export let params = {
  'category': 'animation',
  'parameters': {
    'size': {
      'default': {
        'key': '600 x 600',
        'value': [600, 600],
        'label': '600 x 600'
      },
      'label': 'Afmeting',
      'type': 'array',
      'values': [
        {
          'key': '1500 x 1500',
          'value': [1500, 1500],
          'label': '1500 x 1500'
        },
        {
          'key': '1200 x 1200',
          'value': [1200, 1200],
          'label': '1200 x 1200'
        },
        {
          'key': '900 x 900',
          'value': [900, 900],
          'label': '900 x 900'
        },
        {
          'key': '600 x 600',
          'value': [600, 600],
          'label': '600 x 600'
        },
        {
          'key': '400 x 400',
          'value': [400, 400],
          'label': '400 x 400'
        },
        {
          'key': '300 x 300',
          'value': [300, 300],
          'label': '300 x 300'
        },
      ],
      'control': 'standard-select',
      'description': 'Afmeting van de visualisatie',
    },
    'width': {
      'default': 600,
      'label': 'Breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'height': {
      'default': 600,
      'label': 'Hoogte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'text': {
      'default': 'In februari 2018 zijn er 48 bedrijven\nminder failliet verklaard dan in januari.\n\nDit is het laagste aantal in één maand\nuitgesproken faillissementen sinds\n2001.\n\nDe meeste faillissementen in februari\nzijn uitgesproken in de handel.',
      'label': 'Tekst',
      'type': 'string',
      'control': 'standard-textarea',
    },
    'textFontSize': {
      'default': 30,
      'label': 'Font grootte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textLineHeight': {
      'default': 1.3,
      'label': 'Regelhoogte tekst',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'textFontColor': {
      'default': '#54646c',
      'label': 'Font kleur tekst',
      'type': 'string',
      'control': 'standard-control',
    },
    'colorScheme': {
      'default': {
        'key': 'Abn',
        'label': 'ABN',
        'value': ['#f1f5f6', '#009286'],
      },
      'control': 'cbs-color-scheme',
    },
    'marginLeft': {
      'default': 40,
      'label': 'Linkermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginRight': {
      'default': 30,
      'label': 'Rechtermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginTop': {
      'default': 100,
      'label': 'Bovenmarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'marginBottom': {
      'default': 120,
      'label': 'Ondermarge',
      'type': 'numeric',
      'control': 'standard-number',
    },
   'logoBackgroundColor': {
      'default': '#f1f5f6',
      'label': 'logoBackgroundColor',
      'type': 'number',
      'control': 'standard-control',
    },
    'logoY': {
      'default': 50,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'logoX': {
      'default': 550,
      'label': 'Logo Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'logoWidth': {
      'default': 45,
      'label': 'Logo Width',
      'type': 'number',
      'control': 'standard-number',
    },
    'logoColor': {
      'default': '#00B3D5',
      'label': 'Kleur logo',
      'type': 'string',
      'control': 'standard-number',
    },
    'payoffY': {
      'default': 500,
      'label': 'Payoff Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'payoffFontSize': {
      'default': 42,
      'label': 'Font grootte payoff',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'cbsPayoffFontColor': {
      'default': '#0058b8',
      'label': 'Kleur payoff',
      'type': 'string',
      'control': 'standard-number',
    },
    'backgroundBorderRadius': {
      'default': 5,
      'label': 'Achtergrond rand radius',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bannerOffset': {
      'default': 20,
      'label': 'Margin top header',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleOffsetX': {
      'default': 17,
      'label': 'Titel afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title1OffsetY': {
      'default': 40,
      'label': 'Titel 1 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'title2OffsetY': {
      'default': 78,
      'label': 'Titel 2 afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleText1': {
      'default': 'Uitgesproken faillissementen',
      'label': 'Titel tekst 1',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleText2': {
      'default': 'in Nederland',
      'label': 'Titel tekst 2',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleColor': {
      'default': '#FFFFFF',
      'label': 'Titel kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'titleFontSize': {
      'default': 32,
      'label': 'Titel font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'titleFontWeight': {
      'default': 500,
      'label': 'Titel font dikte',
      'type': 'numeric',
      'control': 'standard-control',
    },
    'minY': {
      'default': 0,
      'label': 'Min Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'maxY': {
      'default': 15000,
      'label': 'Max Y',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'steps': {
      'default': 2,
      'label': 'Steps',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Aantal horizontale lijnen excl. as',
    },
    'unitText': {
      'default': 'Aantal',
      'label': 'Tekst eenheid',
      'type': 'string',
      'control': 'standard-control',
    },
    'unitTextOffsetY': {
      'default': 35,
      'label': 'Afstand unit boven max',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelSpaceY': {
      'default': 60,
      'label': 'Label ruimte Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Ruimte voor de labelteksten langs de Y-as',
    },
    'labelSpaceX': {
      'default': 20,
      'label': 'Label ruimte X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelColor': {
      'default': '#54646c',
      'label': 'Label kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'labelFontSize': {
      'default': 25,
      'label': 'Label font grootte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'labelFontFamily': {
      'default': 'Arial,Helvetica,sans-serif',
      'label': 'Label font',
      'type': 'string',
      'control': 'standard-select',
    },
    'legendFontFamily': {
      'default': 'Arial,Helvetica,sans-serif',
      'label': 'Label font',
      'type': 'string',
      'control': 'standard-select',
    },
    'labelOffsetY': {
      'default': 10,
      'label': 'Label afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand tussen de labels en de Y-as',
    },
    'labelOffsetX': {
      'default': 15,
      'label': 'Label afstand X',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legend': {
      'default': true,
      'label': 'Show legend',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'bronText': {
      'default': 'Bron: CBS',
      'label': 'Data bron',
      'type': 'string',
      'control': 'standard-control',
    },
    'bronTextBottomOffset': {
      'default': 20,
      'label': 'Afstand van de Bron tekst naar de onderkant',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'bronTextLeftOffset': {
      'default': 15,
      'label': 'Afstand van de Bron tekst naar de onderkant',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemWidth' : {
      'default': 30,
      'label': 'Breede van het legend item',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Is de breede van het ledgend item voor de tekst',
    },
    'legendOffsetY' : {
      'default': 70,
      'label': 'Y offset legenda',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Offset van de legends naar de grafiek erboven',
    },
    'legendSpaceBetweenColumns' : {
      'default': 180,
      'label': 'Breede legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendItemDistance' : {
      'default': 30,
      'label': 'Afstand tussen de legenda items',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'legendFontSize' : {
      'default': 25,
      'label': 'Lettergrotte in de legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'ledgendSpaceBetweenItemAndText': {
      'default': 5,
      'label': 'Afstand tussen item en tekst in legenda',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'formatLocale': {
      'default': {
        'key': 'nl-nl',
        'value': 'nl-nl',
        'label': 'Nederlands'
      },
      'label': 'Taal',
      'type': 'string',
      'values' : [
        {
          'key': 'nl-nl',
          'value': 'nl-nl',
          'label': 'Nederlands'
        },
        {
          'key': 'en-gb',
          'value': 'en-gb',
          'label': 'Engels'
        }
      ],
      'control': 'standard-select',
      'description': 'Taal voor het formatteren van de Y-as labels',
    },
    'labelDecimalsY': {
      'default': '0',
      'label': 'Label decimalen y',
      'type': 'number',
      'control': 'standard-number',
      'description': 'Aantal cijfers achter de komma in de Y-as labels',
    },
    'leftLabelX': {
      'default': '1981',
      'label': 'Linker label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'rightLabelX': {
      'default': '2017',
      'label': 'Rechter label X',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStroke': {
      'default': '#FFFFFF',
      'label': 'As kleur',
      'type': 'string',
      'control': 'standard-control',
    },
    'axisStrokeWidth': {
      'default': 3,
      'label': 'As breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineStrokes': {
      'default': ['#009286', '#f3c000', '#99bf00', '#166582'],
      'label': 'Lijn kleuren',
    },
    'lineStrokeWidth': {
      'default': 5,
      'label': 'Lijn breedte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'lineJoin': {
      'default': {
        'key': 'miter',
        'value': 'miter',
        'label': 'Punt'
      },
      'label': 'Lijn aansluiting',
      'type': 'string',
      'values': [
        {
          'key': 'miter',
          'value': 'miter',
          'label': 'Punt'
        },
        {
          'key': 'round',
          'value': 'round',
          'label': 'Afgerond'
        }
      ],
      'control': 'standard-select',
      'description': 'Wijze waarop de lijnaasluitingen worden getekend',
    },
    'icon': {
      'default': '13A',
      'control': 'cbs-svg-icon',
    },
    'iconShow': {
      'default': true,
      'label': 'Show icoon',
      'type': 'boolean',
      'control': 'standard-checkbox',
    },
    'iconWidth': {
      'default': 140,
      'label': 'Icoon breedte',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Breedte van het icoon',
    },
    'iconStrokeWidth': {
      'default': 3,
      'label': 'Icoon font dikte',
      'type': 'numeric',
      'control': 'standard-number',
    },
    'iconOffsetDeltaX': {
      'default': 0,
      'label': 'Icoon afstand delta X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetDeltaY': {
      'default': 0,
      'label': 'Icoon afstand delta Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Verschuiving van het icoon in de x-richting',
    },
    'iconOffsetX': {
      'default': 440,
      'label': 'Icoon afstand X',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de linkerkant',
    },
    'iconOffsetY': {
      'default': 35,
      'label': 'Icoon afstand Y',
      'type': 'numeric',
      'control': 'standard-number',
      'description': 'Afstand van het icoon t.o.v. de bovenkant',
    },
  },
  'timings': {
    'pauseSlide1': {
      'default': 6,
      'label': 'Pause tussen de slides',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseSlide2': {
      'default': 10,
      'label': 'Pause slide 2',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide1Animation': {
      'default': 7,
      'label': 'Slide 1 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'slide2Animation': {
      'default': 5,
      'label': 'Slide 2 animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'logoAnimation': {
      'default': 1,
      'label': 'Logo animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'payoffAnimation': {
      'default': 1,
      'label': 'Payoff animation',
      'type': 'numeric',
      'control': 'standard-number'
    },
    'pauseEnd': {
      'default': 3,
      'label': 'Pause aan het einde',
      'type': 'numeric',
      'control': 'standard-number'
    }
  },
  'data': {
    'values': [['Totaal', 'Natuurlijke personen',	'Bedrijven en instellingen'],
      [7288, 4087, 3201], [8644, 4708, 3936], [7691, 4385, 3306], [6224, 3585, 2639], [5378, 3020, 2358], [4448, 2530, 1918], [3786, 2146, 1640], [3849, 2174, 1675], [3679, 2118, 1561], [3519, 1992, 1527], [4075, 2122, 1953], [5045, 2544, 2501], [6428, 3064, 3364], [6464, 3304, 3160], [5847, 3075, 2772], [5577, 2942, 2635], [5547, 2866, 2681], [5031, 2561, 2470], [3840, 1527, 2313], [4498, 1877, 2621], [5834, 2501, 3333], [6771, 2686, 4085], [8748, 3513, 5235], [9349, 4082, 5267], [10082,	4999, 5083], [9179, 4951, 4228], [7952, 4363, 3589], [6847, 3005, 3842], [10471, 3529, 6942], [9491, 3329, 6162], [9531, 3414, 6117], [11348, 3999, 7349], [12449, 4073, 8376], [9669, 3024, 6645], [7338, 2067, 5271], [5952, 1553, 4399], [4620, 1329, 3291]],
    'columnLimitMin': 1,
    'columnLimitMax': 4,
    'columnLabelNumber': 1,
    'rowLimitMin': 2,
    'rowLimitMax': 100,
    'rowLabelNumber': 0,
  },
  'parameterGroups': [
    {
      'title': 'Primair',
      'collapsed': false,
      'keys': ['size', 'titleText1', 'titleText2', 'text', 'minY', 'maxY', 'unitText', 'leftLabelX', 'rightLabelX'],
    },
    {
      'title': 'Secundair',
      'collapsed': true,
      'keys': ['steps', 'formatLocale', 'labelDecimalsY', 'legendOffsetY', 'legendSpaceBetweenColumns'],
    }
  ],
  'timingGroups': [
    {
      'title': 'Timing',
      'collapsed': true,
      'keys': ['slide1Animation', 'pauseSlide1', 'pauseSlide2', 'logoAnimation', 'payoffAnimation', 'pauseEnd']
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/animations/demo-abn-triptych-line-hor-steps/social.params.ts